<template>
  <div :style="{ height: height }" class="sellCenter">
    <div class="inputWrap">
      <div class="header" ref="header">
        <el-page-header
          @back="goBack"
          :content="$route.query.id ? '编辑商品' : '创建商品'"
        >
        </el-page-header>
        <div>
          <el-button type="info" size="mini" @click="onSubmit">{{
            $route.query.id ? "提交修改" : "提交创建"
          }}</el-button>
        </div>
      </div>

      <div
        :style="{ height: formHeight + 'px', backgroundColor: '#fff' }"
        class="formBox"
      >
        <el-form ref="form" :model="form" size="mini" label-width="80px">
          <div class="formInfo">
            <el-alert
              v-show="showErr.show"
              :title="showErr.text"
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <div class="formInnerBox" :style="{ height: formHeight - 40 + 'px' }">
            <el-form-item label="商品联系人">
              <el-select v-model="form.empUserId" placeholder="选择商品联系人">
                <el-option
                  v-for="(item, index) in userEmployeeData"
                  :key="index"
                  :label="item.name"
                  :value="item.userId"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="forItem" label="商品名称">
              <el-input
                placeholder="请输入商品名称"
                v-model="form.name"
              ></el-input>
              <!-- <span
            v-if="!form.name.value"
            class="warning"
          >{{form.name.warning}}</span> -->
            </el-form-item>

            <el-form-item label="产品分类">
              <el-cascader
                v-model="form.types"
                :options="myAllTypes"
                @change="allTypeChange"
              ></el-cascader>
            </el-form-item>

            <el-form-item label="等级">
              <el-select v-model="form.grade" placeholder="请选择计价">
                <el-option
                  :key="index"
                  v-for="(item, index) in gradeData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="计价单位">
              <el-select v-model="form.unit" placeholder="请选择计价">
                <el-option
                  :key="index"
                  v-for="(item, index) in unitData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="购买单位">
              <el-select v-model="form.buyUnit" placeholder="请选择购买单位">
                <el-option
                  :key="index"
                  v-for="(item, index) in unitData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item class="forItem" label="商品价格">
              <el-input placeholder="请输入商品价格" v-model="form.price">
                <template slot="append">{{ `元/${form.unit}` }}</template>
              </el-input>
            </el-form-item>

            <el-form-item class="forItem" label="产品说明">
              <el-input type="textarea" rows="3" v-model="form.spec"></el-input>
            </el-form-item>

            <el-form-item v-if="form.unit!=form.buyUnit" class="forItem" label="单位商品(均重/数量)">
              <el-input placeholder="请输入单位商品" v-model="form.unitWeight">
                <template slot="append">{{
                  `${form.unit}/${form.buyUnit}`
                }}</template>
              </el-input>
            </el-form-item>

            <el-form-item class="forItem" label="最低购买数量">
              <el-input
                placeholder="请输入最低购买数量"
                v-model="form.minBuyCount"
              >
                <template slot="append">{{ `${form.buyUnit}` }}</template>
              </el-input>
            </el-form-item>

            <el-form-item label="商品来源">
              <el-select
                @change="commoditySourceChange"
                v-model="form.birthType"
                placeholder="请选择商品来源"
              >
                <el-option label="国内商品" :value="1"></el-option>
                <el-option label="国外商品" :value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="产地">
              <el-select v-model="form.birthPlace" placeholder="请选择产地">
                <el-option
                  :key="index"
                  v-for="(item, index) in birthPlaceData"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="仓库地址">
              <el-cascader v-model="form.addrId" :options="citys"></el-cascader>
            </el-form-item>

            <el-form-item class="forItem" label="仓库详细地址">
              <el-input v-model="form.address"></el-input>
            </el-form-item>

            <el-form-item class="forItem" label="卖家备注说明">
              <el-input
                type="textarea"
                rows="3"
                v-model="form.remark"
              ></el-input>
            </el-form-item>

            <el-form-item label="保存为模版">
              <el-switch
                @change="isSaveChange"
                v-model="form.isSave"
              ></el-switch>
            </el-form-item>

            <el-form-item label="选择封面图" label-width="120px">
              <!-- <div @click="tragerMyUpload">
                <i class="el-icon-plus icon-my-up"></i>
                <img
                  :src="upLoadImg.src"
                  v-show="upLoadImg.show"
                  class="uploadImg"
                  alt
                />
              </div>
              <div v-show="updata_qualified" class="upload-my-tips">
                上传照片格式仅限:png,jpg,jpeg
              </div>
              <div v-show="updata_qualified_size" class="upload-my-tips">
                图片需小于2M
              </div>
              <div>
                <input
                  v-show="false"
                  class="file"
                  ref="update"
                  type="file"
                  @change="update"
                />
              </div> -->
              <UploadFile
                :multitude="false"
                :initData="currentEditRow &&currentEditRow.coverPlan"
                @uploadSuccess="(url) => uploadSucces(url, 1)"
              ></UploadFile>
            </el-form-item>

            <el-form-item label="商品详情" label-width="120px">
              <UploadFile
                :multitude="true"
               :initData="currentEditRow && currentEditRow.image"
                @uploadSuccess="(url) => uploadSucces(url, 2)"
              ></UploadFile>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

import SparkMD5 from "spark-md5";
import {
  baseUrl,
  addGoodsUrl,
  queryStoreEmployee,
  queryAllClassCategry,
  gradeData,
  unitData,
  internationCity,
  getImageUrl,
  getAreaByAreaId,
  updateGoodsUrl
} from "@/api/api";

import citys from "@/utils/city.js";
export default {
  props: ["height"],
  data() {
    return {
      form: {
        empUserId: "",
        name: "",
        types: [],
        goodsType: "",
        breed: "",
        grade: "",
        unit: "",
        buyUnit: "",
        price: "",
        spec: "",
        unitWeight: "",
        minBuyCount: "",
        birthType: "",
        birthPlace: "",
        addrId: null,
        remark: "",
        address: "",
        coverPlan: "",
        image: "",
        isSave: false,
      },

      userEmployeeData: [],
      myAllTypes: [],

      birthPlaceData: citys,

      updata_qualified: false,
      updata_qualified_size: false,

      upLoadImg: { show: false, src: "" },
      upLoadImg1: { show: false, src: "" },
      formHeight: "",
      showErr: {
        show: false,
        text: "",
      },
      kind:'1'
    };
  },
  created() {
    this.gradeData = gradeData;
    this.unitData = unitData;
    this.internationCity = internationCity;
    this.citys = citys;
    this.getImageUrl = getImageUrl;
    this.getAreaByAreaId = getAreaByAreaId;

    this.initStoreEmployee();
    this.initMyTypes();

    console.log(this.userInfo);
    console.log(this.companyInfo);
  },

  mounted() {
    this.setFormHeight();
    window.addEventListener("resize", this.setFormHeight);
    if (this.$route.query.id) {
      if (
        this.currentEditRow &&
        this.currentEditRow.id == this.$route.query.id
      ) {
        this.initState();
      }
    }
  },

  computed: {
    ...mapState(["userInfo", "companyInfo", "currentEditRow"]),
  },
  methods: {
    initState() {
      console.log("currentEditRow", this.currentEditRow);

      let {
        empId,
        name,
        types,
        goodsType,
        breed,
        grade,
        unit,
        buyUnit,
        price,
        spec,
        unitWeight,
        minBuyCount,
        birthType,
        birthPlace,
        addrId,
        remark,
        address,
        coverPlan,
        image
      } = this.currentEditRow;
      console.log([
        String(addrId).substr(0, 2) + "0000",
        String(addrId).substr(0, 4) + "00",
        String(addrId),
      ]);

      addrId = String(addrId);

      // image = image&&image.split(',').map((item)=>(this.getImageUrl(item, "o")))

      let form = {
        empUserId: empId,
        name,
        types: types ? types.split(",") : [],
        goodsType,
        breed,
        grade,
        unit,
        buyUnit,
        price,
        spec,
        unitWeight,
        minBuyCount,
        birthType,
        birthPlace,
        addrId,
        remark,
        address,
        coverPlan,
        image,
        isSave: false,
      };
      this.form = form;
      this.$forceUpdate();
    },
    uploadSucces(url, type) {
      if (type == 1) {
        //封面图
        this.form = {
          ...this.form,
          coverPlan: url.url,
        };
      } else if (type == 2) {
        //详情图
        this.form = {
          ...this.form,
          image: url.url,
        };
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setFormHeight() {
      setTimeout(() => {
        this.formHeight =
          parseFloat(this.height) - this.$refs.header.clientHeight - 100;
      },100);
    },
    initMyTypes() {
      let that = this;
      let url = queryAllClassCategry;
      let { storeId } = this.userInfo;
      let { type } = this.companyInfo;
      let kind = 1;
      // if (type == 6 || type == 7 || type == 8) {
      //   kind = 3;
      // } else if (type == 4 || type == 9) {
      //   kind = 2;
      // } else if (type == 1 || type == 2 || type == 3 || type == 5) {
      //   kind = 1;
      // }

      	if (type == 6) {
					kind = '3,4'
				}else if(type == 7 ){
					//动保厂
					kind="4,6"
				}else if(type == 8){
					//添加剂
					kind="4,6"
				} else if (type == 4) {
					kind = '2,4,1'
				} else if (type == 9) {
					kind = '2,4'
				} else if ( type == 2 || type == 3 || type == 5) {
					kind = '1,4'
				}else if(type == 1){
        kind = '1,3,4'
        }

      this.kind = kind
      let data = {
        kind,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            console.log(data);
            this.regroupMyTypes(data);
          }else{
            this.$alert(res.data.resultMsg)
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err))
        });
    },
    regroupMyTypes(data) {
      this.myAllTypes = data.map((item, index) => {
        item.label = item.typeName;
        item.value = item.typeId;
        item.tlist &&
          item.tlist.map((subItem, index) => {
            subItem.label = subItem.typeName;
            subItem.value = subItem.typeId;

            subItem.tlist &&
              subItem.tlist.map((thItem, index) => {
                thItem.label = thItem.typeName;
                thItem.value = thItem.typeId;
                console.log(thItem.tlist);
                thItem.children = thItem.tlist;
                return thItem;
              });
            console.log(subItem.tlist);
            subItem.children =
              subItem.tlist.length > 0
                ? subItem.tlist
                : [{ value: "", label: "无" }];
            return subItem;
          });

        item.children = item.tlist;
        return item;
      });
      console.log(this.myAllTypes);
    },
    allTypeChange(types) {
      console.log(types);
      console.log(this.myAllTypes);
      let goodsType = "",
        breed = [];

      this.myAllTypes &&
        this.myAllTypes.forEach((item, index) => {
          if (item.typeId == types[0]) {
            console.log(item.label);
            goodsType = item.label;
            breed.push(item.label);
            item.tlist.forEach((subItem, index) => {
              if (subItem.typeId == types[1]) {
                console.log(subItem.label);
                breed.push(subItem.label);
                subItem.tlist &&
                  subItem.tlist.forEach((thItem, index) => {
                    if (thItem.typeId == types[2]) {
                      console.log(thItem.label);
                      breed.push(thItem.label);
                    }
                  });
              }
            });
          }
        });
      console.log(goodsType, breed);
      let form1 = JSON.parse(JSON.stringify(this.form));
      console.log(form1);
      form1.goodsType = goodsType;
      form1.breed = breed.join(",");
      console.log(1111);
      console.log(form1);

      this.form = form1;
      console.log(222);
      console.log(this.form);
    },
    isSaveChange(val) {
      // alert(val)
    },
    commoditySourceChange(val) {
      this.form.birthPlace = "";
      this.birthPlaceData = val == 2 ? internationCity : citys;
    },
    onSubmit() {
      if (true) {
        console.log(this.form);
        let {
          addrId,
          address,
          birthPlace,
          birthType,
          breed,
          buyUnit,
          coverPlan,
          empUserId,
          goodsType,
          grade,
          image,
          isSave,
          minBuyCount,
          name,
          price,
          remark,
          spec,
          types,
          unit,
          unitWeight,
        } = this.form;
        if (!empUserId) {
          this.showErr = {
            show: true,
            text: "请填写商品联系人",
          };
          return;
        }

        if (!name) {
          this.showErr = {
            show: true,
            text: "请填写商品名称",
          };
          return;
        }
        if (!types) {
          this.showErr = {
            show: true,
            text: "请选择产品分类",
          };
          return;
        }
        if (!birthType) {
          this.showErr = {
            show: true,
            text: "请选择商品来源",
          };
          return;
        }

        if (!unit) {
          this.showErr = {
            show: true,
            text: "请选择计价单位",
          };
          return;
        }
        if (!price) {
          this.showErr = {
            show: true,
            text: "请输入商品价格",
          };
          return;
        }

        if((!addrId)||(addrId=='null')){
          this.showErr = {
            show: true,
            text: "请选择仓库地址",
          };
          return;
        }
        if (!buyUnit) {
          this.showErr = {
            show: true,
            text: "请选择购买单位",
          };
          return;
        }
        if (!minBuyCount) {
          this.showErr = {
            show: true,
            text: "请输入最小购买数量，最小为1",
          };
          return;
        }
         if (minBuyCount<=0) {
          this.showErr = {
            show: true,
            text: "请输入有效最小购买数量",
          };
          return;
        }

         if (minBuyCount!=parseInt(minBuyCount)) {
          this.showErr = {
            show: true,
            text: "最小购买数量需为整数数字，最小为1",
          };
          return;
        }

        if(!address){
          this.showErr = {
            show: true,
            text: "请填写仓库详细地址",
          };
          return;
        }

        if (!coverPlan) {
          this.showErr = {
            show: true,
            text: "请上传商品封面图",
          };
          return;
        }

        if (!image) {
          this.showErr = {
            show: true,
            text: "请上传商品详情图",
          };
          return;
        }

        this.showErr = {
          show: false,
          text: "",
        };

        let { s_name: storeName, storeId } = this.companyInfo;
        let { access_token } = this.userInfo;
        let subData = {
          addrId: Array.isArray(addrId) ? addrId[2] : addrId,
          address,
          birthPlace,
          birthType,
          breed,
          buyUnit,
          coverPlan,
          empUserId,
          goodsType,
          grade,
          image,
          isSave: isSave ? 1 : "",
          minBuyCount,
          name: name,
          price,
          remark,
          spec,
          types: types ? types.join(",") : "",
          unit,
          unitWeight,
          storeId,
          storeName,
          access_token,
          kind:this.kind?this.kind.substr(0,1):1
        };
        console.log(subData);
        // return
        let that = this;
        let url = this.$route.query.id?updateGoodsUrl:addGoodsUrl;
        if(this.$route.query.id){
          subData.gid = this.$route.query.id
        }
        let data = subData;
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
              const { data } = res.data;
              console.log(data);
              this.$router.go(-1);
            } else {
              this.$alert(JSON.stringify(res.data.resultMsg || "请求异常"));
            }
          })
          .catch((err) => {
            if (err) {
              this.$alert(JSON.stringify(err));
            } else {
              this.$alert('请求异常');
            }
          });
      }
    },
    testAddAddres(form) {
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          let showTips = [];
          reg.forEach((item) => {
            if (!item.rule.test(value)) {
              form[k].warning = item.info;
              flag = false;
              showTips.push(true);
            } else {
              showTips.push(false);
            }
          });
          console.log(showTips);
          showTips.every((item) => item == false) && (form[k].warning = "");
        }
      }
      return flag;
    },
    initStoreEmployee() {
      let that = this;
      let url = queryStoreEmployee;
      let { storeId } = this.userInfo;
      let data = {
        storeId,
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            this.userEmployeeData = data;
          }else{
            this.$alert(res.data.resultMsg)
          }
        })
        .catch((err) => {
           this.$alert(JSON.stringify(err))
        });
    },
  },
};
</script>
<style scoped lang="less">
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 20px;
}
.formBox {
  margin-top: 20px;
  padding: 20px;
}
.forItem {
  width: 266px;
}
.formInnerBox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 550px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  width: 300px;
  height: 30px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/CommodityAdd.vue